export default __webpack_public_path__ + "static/media/canalizacion_vena_arteria_umbilical.076a174d.pdf";